import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import App from './App';
import * as serviceWorker from './serviceWorker';
import './dist/css/main.min.css';
import { store } from './reducers'

ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>,
	document.getElementById('root')
);

serviceWorker.register();


// WEBPACK FOOTER //
// ./src/index.js